const ASSET_FORMS = {
  machine: "MACHINE-FORM",
  user: "USER-FORM"
};
export const getAssetFormModal = (assetType) => ASSET_FORMS[assetType];
